import React from 'react';
import { Modal, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { ITicket } from '../ticketModels';

interface TicketUseConfirmModalProps {
    visible: boolean;
    ticket: ITicket | null;
    loading: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const TicketUseConfirmModal: React.FC<TicketUseConfirmModalProps> = ({
    visible,
    ticket,
    loading,
    onConfirm,
    onCancel,
}) => {
    return (
        <Modal
            title={
                <div className="text-xl md:text-2xl font-bold text-center">
                    <CheckCircleOutlined className="text-green-500 mr-2" />
                    Xác nhận sử dụng phiếu
                </div>
            }
            open={visible}
            onCancel={onCancel}
            footer={null}
            width="65%"
            style={{ maxWidth: 600 }}
            centered
        >
            {ticket && (
                <div className="space-y-4 md:space-y-6 py-2 md:py-4">
                    <div className="bg-blue-50 rounded-lg p-4 md:p-6 space-y-3">
                        <div className="text-center">
                            <h3 className="text-xl md:text-2xl font-bold text-gray-800 break-words">{ticket.studentName}</h3>
                            <p className="text-gray-600 text-base md:text-lg">MSSV: {ticket.studentUserInternalId}</p>
                        </div>
                        <div className="border-t pt-3 space-y-2">
                            <div className="flex justify-between text-base md:text-lg flex-wrap gap-2">
                                <span className="text-gray-600">Loại phiếu:</span>
                                <span className="font-bold break-words text-right">{ticket.ticketTypeName}</span>
                            </div>
                            <div className="flex justify-between text-base md:text-lg flex-wrap gap-2">
                                <span className="text-gray-600">Mã phiếu:</span>
                                <span className="font-mono font-bold text-blue-600 break-all text-right">{ticket.code}</span>
                            </div>
                        </div>
                    </div>

                    <p className="text-center text-gray-600 text-base md:text-lg px-2">
                        Bạn có chắc chắn muốn sử dụng phiếu này không?
                    </p>

                    <div className="flex gap-2 md:gap-3">
                        <Button
                            size="large"
                            block
                            onClick={onCancel}
                            className="h-12 md:h-14 text-base md:text-lg"
                        >
                            Hủy
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            block
                            onClick={onConfirm}
                            loading={loading}
                            icon={<CheckCircleOutlined />}
                            className="h-12 md:h-14 text-base md:text-lg font-bold"
                        >
                            Xác nhận
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default TicketUseConfirmModal;
